import { useReducer } from 'react';

const useForceUpdate = (): (() => void) => {
  return useReducer(() => ({}), {})[1] as () => void; // <- paste here
};

export default useForceUpdate;
